import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ReplaySubject } from 'rxjs/';

@Injectable()

/**
 * This service controlls the navigation between the elements.
 */
export class NaviService {
  private currentPage: String = 'index'; // Which page is the current Page
  public pageChanger: ReplaySubject<any> = new ReplaySubject(1);

  /**
   * This constructor identifies the current page
   * @param router
   * @param activatedRoute
   */
  constructor(private router: Router, private activatedRoute: ActivatedRoute) {
    // Getting url
    const url: String = location.pathname;
    switch (url) {
      case '/':
      case '/index.html':
      case '/index':
      case '/about':
      case '/imprint':
      case '/disclaimer':
      case '/registration':
      case '/forgot-password':
      case '/email/user/verify':
      case '/email/user/reverify':
      case '/email/password/reset':
      case '': this.currentPage = 'nologin';
        break;
      case '/login': this.currentPage = 'login';
        break;
      case '/dashboard': this.currentPage = 'dashboard';
        break;
      case 'hcp/dashboard': this.currentPage = 'hcpdashboard';
        break;
      case '/group-details': this.currentPage = 'group-details';
        break;
      case '/groups': this.currentPage = 'groups';
        break;
      case '/group-details-member': this.currentPage = 'group-details-member';
        break;
      case '/group-details-collaborator': this.currentPage = 'group-details-collaborator';
        break;
      case '/group-details-statistics': this.currentPage = 'group-details-statistics';
        break;
      case '/mygroups': this.currentPage = 'mygroups';
        break;
      case 'hcp/managing-groups': this.currentPage = 'managing-groups';
        break;
      case '/my-profile': this.currentPage = 'my-profile';
        break;
      case '/group-details-patient': this.currentPage = 'group-details-patient';
        break;
      case '/myquestionnaires': this.currentPage = 'myquestionnaires';
        break;
      case 'hcp/messages': this.currentPage = 'hcpmessages';
        break;
      case 'hcp/messages': this.currentPage = 'hcpmessages';
        break;
      case 'hcp/alarms': this.currentPage = 'hcpalarms';
        break;
      case 'messages':
      case '/messages': this.currentPage = 'messages';
        break;
      case 'messages/new':
      case '/messages/new': this.currentPage = 'messages';
        break;
      case 'registration': this.currentPage = 'registration';
        break;
      case 'forgot-password': this.currentPage = 'forgot-password';
        break;
      case 'verified': this.currentPage = 'verified';
        break;
      case 'set-new-password': this.currentPage = 'set-new-password';
        break;
      case 'invitations': this.currentPage = 'invitations';
        break;
      default: this.currentPage = location.pathname;
    }
  }

  /**
   * Returning the current page
   * @return String with current page
   */
  public getCurrentPage(): String {
    return this.currentPage;
  }

  /**
   * This function sets the new currentPage. Searching if the identifier was found.
   * @param nextPage string of next page to be loaded
   */
  public setCurrentPage(nextPage: String): void {
    let url = '';
    switch (nextPage) {
      case 'nologin': url = '/index';
        break;
      case 'index': url = '/index';
        break;
      case 'about': url = '/about';
        break;
      case 'imprint': url = '/imprint';
        break;
      case 'disclaimer': url = '/disclaimer';
        break;
      case 'login': url = '/login';
        break;
      case 'dashboard': url = '/dashboard';
        break;
      case 'hcpdashboard': url = 'hcp/dashboard';
        break;
      case 'group-details': url = '/group-details';
        break;
      case 'groups': url = '/groups';
        break;
      case 'group-details-member': url = '/group-details-member';
        break;
      case 'group-details-collaborator': url = '/group-details-collaborator';
        break;
      case 'group-details-statistics': url = '/group-details-statistics';
        break;
      case 'mygroups': url = '/mygroups';
        break;
      case 'managing-groups': url = 'hcp/managing-groups';
        break;
      case 'my-profile': url = '/my-profile';
        break;
      case 'group-details-patient': url = '/group-details-patient';
        break;
      case 'myquestionnaires': url = '/myquestionnaires';
        break;
      case 'hcpmessages': url = 'hcp/messages';
        break;
      case 'hcpmessagesNew': url = 'hcp/messages/new';
        nextPage = 'hcpmessages';
        break;
      case 'hcpalarms': url = 'hcp/alarms';
        break;
      case 'registration': url = '/registration';
        break;
      case 'forgot-password': url = '/forgot-password';
        break;
      case 'verified': url = '/verified';
        break;
      case 'messages': url = '/messages';
        break;
      case 'messagesNew': url = '/messages/new';
        nextPage = 'messages';
        break;
      case 'set-new-password': url = '/set-new-password';
        break;
      case 'invitations': url = '/invitations';
        break;
      default: console.log('---NaviService---: No root found for page: ' + nextPage);
        nextPage = 'index';
        url = '/';
    }

    this.currentPage = nextPage;

    // Navigate to the route
    this.router.navigateByUrl(url);
    this.pageChanger.next(nextPage);
  }

  /**
   * This function navigates to the given url without checking the availability of the route.
   * @param url url to be navigated to, this route will be accepted without checking
   * @param nextPage next page of the url
   */
  public navigateToUrl(url: String, nextPage: String) {
    this.currentPage = nextPage;
    this.router.navigateByUrl(url.toString());
    this.pageChanger.next(nextPage);
  }

}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/services/navi.service.ts